import axios from 'axios';
import { API_URL } from '../../../constants';

const SURVEY_PATH = 'api/v1/surveys/student_seca_surveys';

const handleResponse = async (request) => {
  let response;
  try {
    response = await request;
  } catch (e) {
    if (!e.response) {
      throw e; // Network issue
    }
    response = e.response;
  }
  switch(response.status) {
    case 404:
      throw new Error('inviteLinkError');
    case 200:
      return;
    default:
      throw new Error(`System Error: ${response.data}`);
  }
};

export const submit = (surveyId, answers) => handleResponse(axios.patch(`${API_URL}/${SURVEY_PATH}/${surveyId}`, { answers }));

export const validate = (surveyId) => handleResponse(axios.get(`${API_URL}/${SURVEY_PATH}/${surveyId}`));

